__turbopack_context__.v({
  "card": "ExpandableSelect-module-scss-module__grTwDa__card",
  "children": "ExpandableSelect-module-scss-module__grTwDa__children",
  "disabled": "ExpandableSelect-module-scss-module__grTwDa__disabled",
  "dropdown-toggle": "ExpandableSelect-module-scss-module__grTwDa__dropdown-toggle",
  "label": "ExpandableSelect-module-scss-module__grTwDa__label",
  "loader-wrapper": "ExpandableSelect-module-scss-module__grTwDa__loader-wrapper",
  "open": "ExpandableSelect-module-scss-module__grTwDa__open",
  "second-line": "ExpandableSelect-module-scss-module__grTwDa__second-line",
  "selected": "ExpandableSelect-module-scss-module__grTwDa__selected",
  "skeleton": "ExpandableSelect-module-scss-module__grTwDa__skeleton",
});
